import { TemplateData, TemplateParams } from '.';

const pathDeadlineEmailList = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'paths',
  email: {
    buttonEnabled: true,
    buttonLink: '{{pathAdminUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.courseDeadlineExpiringForUsers} ${messages.pathInPath}.
      </p>
      <p>
        {{usersList}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.pathStepDeadlineSubject}`
  },
  placeholders: {
    pathTitle: {
      label: messages.pathsPathTitle,
      example: 'Test path'
    },
    pathAdminUrl: {
      label: messages.pathsPathAdminLink,
      example: `${serverConfig.adminUrl}/admin/paths/1`
    },
    usersList: {
      label: messages.emailExpiringDeadlinesUsersList
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypePathDeadlineEmailList
});

export default pathDeadlineEmailList;
